import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditSubAdminPageNews from "../../components/SubAdmin/EditSubadminPageNew";



const EditSubadminPage= () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb id="title" title="Edit Sub Admin" title2="Sub Admin" link2="/subadmin" />

        {/* AddUserLayer */}
        <EditSubAdminPageNews />


      </MasterLayout>
    </>
  );
};

export default EditSubadminPage;
